function initHeader() {



    let headerFlyoutHolder          = document.querySelector('.header-flyout-holder .navholder');
    let headerFlyoutHolderHeight    = headerFlyoutHolder.offsetHeight+5;

    let navHolder                  = document.querySelector('#masthead .nav-holder');
    let mastheadHeight             = navHolder.offsetHeight;
    /*
    let navHolderItems             = navHolder.querySelectorAll('.nav-holder-item');


   
    navHolderItems

    let navHolderTl = new gsap.timeline({paused:true});

    navHolderTl.from(navHolderItems, {y: '-2rem', duration: 0.75, delay: 0,  stagger: 0.1, ease: 'power1.easeinOut'});

    */

    function hasClass(el, cls) {
    
        var regexp = new RegExp('(\\s|^)' + cls + '(\\s|$)'),
            target = (typeof el.className === 'undefined') ? window.event.srcElement : el;
        return target.className.match(regexp); 
    }
    

    function hideBar() {
        gsap.to(headerFlyoutHolder, {
            //opacity: 0, utils
            y: -headerFlyoutHolderHeight, 
            duration: 0.8,
            ease:Power3.easeOut,
            onComplete: function(){
                headerFlyoutHolder.classList.remove('shown');
            }
        });

        gsap.to(navHolder, {
            //opacity: 0, utils
            y: 0, 
            duration: 1.2,
            ease:Power3.easeOut,
            onComplete: function(){
            
            }
        });

        //navHolderTl.play();

    }

    function showBar() {
        
        gsap.to(headerFlyoutHolder, {
            //opacity: 1,
            y: 0,
            duration: 0.8,
            ease:Power3.easeOut,
            onComplete: function(){
                headerFlyoutHolder.classList.add('shown');
            }
        });

        gsap.to(navHolder, {
            //opacity: 0, utils
            y: -mastheadHeight, 
            duration: 1.2,
            ease:Power3.easeOut,
            //delay:0.5,
            //onComplete: function(){
            
            //}
        });

        //navHolderTl.reverse();

       
    }

       


    var delay = 200; // The delay for the setInterval
    var navMovement = setInterval(function() {

        var  pageVertOffset = document.all? iebody.scrollTop : pageYOffset;

    
        if(pageVertOffset >= mastheadHeight && !hasClass(headerFlyoutHolder, 'shown') ) { 

            showBar();

            

        } else if (pageVertOffset < mastheadHeight && hasClass(headerFlyoutHolder, 'shown')) { 

            hideBar();
            
    
        }


    
    }, delay); // Runs every `delay` amount


   

 


}

if (!isMobile) {
   initHeader();
}

